import { N, round, ceil } from './helpers.mjs';

export const TILERS = [
  // ====================== TILERS ======================
  {
    slug: 'tile-quantity',
    trade: 'tilers',
    name: 'Tile Quantity',
    blurb: 'Includes 10% cutting wastage by default.',
    inputs: [
      { key: 'area', label: 'Area to tile', unit: 'm²', placeholder: '8' },
      { key: 'tileW', label: 'Tile width', unit: 'mm', placeholder: '300' },
      { key: 'tileH', label: 'Tile height', unit: 'mm', placeholder: '600' },
      { key: 'wastage', label: 'Wastage', unit: '%', placeholder: '10', default: 10 },
    ],
    compute: (v) => {
      const tileArea = (N(v.tileW) / 1000) * (N(v.tileH) / 1000);
      const tiles = tileArea > 0 ? ceil((N(v.area) / tileArea) * (1 + N(v.wastage) / 100)) : 0;
      return [
        { label: 'Tile area', value: round(tileArea, 3), unit: 'm²/tile' },
        { label: 'Tiles required', value: tiles, unit: 'tiles' },
        { label: 'Adhesive (20kg bags)', value: ceil(N(v.area) / 5), unit: 'bags' },
        { label: 'Grout (3kg bags)', value: ceil(N(v.area) / 8), unit: 'bags' },
      ];
    },
  },

];
